import React from 'react';

const RejectedIcon: React.FC = (): React.ReactElement => {
  return (
    <>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="18"
        height="19"
        viewBox="0 0 18 19"
        fill="none">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M16.955 2.34069L16.1595 1.5452L9 8.70465L1.84054 1.5452L1.04505 2.34069L8.2045 9.50015L1.04505 16.6596L1.84054 17.4551L9 10.2956L16.1595 17.4551L16.955 16.6596L9.79549 9.50015L16.955 2.34069Z"
          fill="white"
        />
      </svg>
    </>
  );
};

export default RejectedIcon;
